import type { ComponentProps } from "react";

import type { ChipToneOrNeutral } from "@/lib/labels/shared";
import { cn } from "@/lib/utils";

interface ToneChipProps extends ComponentProps<"span"> {
	tone: ChipToneOrNeutral;
}

const CHIP = "rounded-md border px-1 py-px text-xs font-medium leading-none";

const TONE_CLASS: Record<ChipToneOrNeutral, string> = {
	amber: "border-warning/40 bg-warning/10 text-warning",
	petrol: "border-primary/40 bg-primary/10 text-primary",
	teal: "border-info/40 bg-info/10 text-info",
	coral: "border-destructive/40 bg-destructive/10 text-destructive",
	neutral: "border-border bg-background text-muted-foreground",
};

export function ToneChip({ tone, className, children, ...rest }: ToneChipProps) {
	return (
		<span className={cn(CHIP, TONE_CLASS[tone], className)} {...rest}>
			{children}
		</span>
	);
}
